module.exports = __webpack_public_path__ + "img/6.929c9aed.png";